import React from 'react';
import { FormikInputView } from './formik-input-view';

export const FormikSelectView = ({
  items,
  sx,
  focused,
  onChange,
  name,
  label,
  className,
  variant = 'outlined',
  formik,
  minWith,
  disabled,
}) => (
  <FormikInputView
    onChange={onChange}
    sx={sx}
    disabled={disabled}
    minWith={minWith}
    label={label}
    className={className}
    name={name}
    variant={variant}
    type="email"
    formik={formik}
    focused={focused}
    items={items}
    select
  />
);
